<template>
<div class="card otp-container">

    <div class="card-header">
        <p class="card-header-title">{{ trans.two_factor_auth }}</p>
    </div>

    <div class="card-content field-label-container" @input="clearValidation">
        <div class="field is-horizontal field-label-container">
            <label for="one-time-password" class="field-label is-normal">
                {{ trans.confirmation_code }}
            </label>

            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input
                            id="one-time-password"
                            type="text"
                            class="input"
                            name="one_time_password"
                            autocomplete="off"
                            required
                            :class="{ 'is-danger': errors.one_time_password }"
                            :placeholder="trans.confirmation_code_placeholder"
                            v-model="form.one_time_password"
                            @keyup.enter="confirm"
                        >
                    </div>
                    <p v-show="errors.one_time_password" class="help is-danger">
                        {{ errors.one_time_password }}
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal login-buttons">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <button
                            class="button is-info"
                            :class="{ 'is-loading': isLoading }"
                            @click="confirm"
                        >
                            {{ trans.confirm }}
                        </button>
                    </p>
                </div>
                <div class="field">
                    <div class="control has-text-right-tablet">
                        <a
                            v-if="actions.reset"
                            :href="actions.reset"
                            class="is-size-7"
                        >
                            {{ trans.having_problems }}
                        </a>
                    </div>
                </div>
                <p v-show="errors.unexpected" class="help is-danger">
                    {{ errors.unexpected }}
                </p>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import { axiosForm } from '../mixins/axiosFormMixin';

    export default {
        mixins: [ axiosForm ],
        props: {
            actions: Object,
        },
        data() {
            return {
                form: {
                    one_time_password: null,
                },
                okReport: 'Успешное прохождение двухфакторной аутентификации',
                failReport: 'Ошибка ввода одноразового пароля при прохождении двухфакторной аутентификации',
            };
        },
        methods: {
            /**
             * Обработчик подтверждения OTP
             */
            confirm(e) {
                this.submit(e, this.actions.verify);
            },

            /**
             * Обработчик ответа сервера
             * @param response
             */
            postResultHandler(response) {
                if (response.data.verified) {
                    window.location.replace(this.actions.success);
                }
            },
        },
    };
</script>
